import type { CSSProperties } from 'react';

/** Autoclipper website palette (landing-page/src/styles.css), shared by the shell and shadow host.
 * Inline host properties take precedence over the generated editor's :host defaults.
 * Keep clip-* tokens and project/media colors unchanged: these variables theme only the UI.
 */
export const STUDIO_THEME_STYLE = {
  '--color-app': 'oklch(0.15 0.02 135)',
  '--color-panel': 'oklch(0.19 0.02 135)',
  '--color-panel-2': 'oklch(0.23 0.02 135)',
  '--color-panel-3': 'oklch(0.3 0.06 135)',
  '--color-line': 'oklch(1 0 0 / 8%)',
  '--color-line-strong': 'oklch(1 0 0 / 12%)',
  '--color-fg': 'oklch(0.98 0.01 135)',
  '--color-muted': 'oklch(0.7 0.02 135)',
  '--color-faint': 'oklch(0.6 0.02 135)',
  '--color-accent': 'oklch(0.88 0.24 130)',
  '--color-accent-strong': 'oklch(0.92 0.22 145)',
  '--color-accent-soft': 'oklch(0.88 0.24 130 / 15%)',
  '--studio-primary-foreground': 'oklch(0.18 0.04 135)',
} as CSSProperties;

/** Mount replaces the shadow children synchronously; add this after each mount, before ready.
 * It also covers dialogs in the editor's shadow portal without touching media/caption styling.
 */
export const applyStudioShadowTheme = (element: HTMLElement): void => {
  if (!element.shadowRoot) return;
  const style = document.createElement('style');
  style.textContent = `
    button.bg-accent.text-white,
    button[class~="hover:bg-accent"]:hover {
      color: var(--studio-primary-foreground);
    }
    button[role="switch"].bg-accent > .bg-white {
      background-color: var(--studio-primary-foreground);
    }
    button:focus-visible,
    [role="slider"]:focus-visible {
      outline: 2px solid var(--color-accent);
      outline-offset: 2px;
    }
    [data-clip-id].border-white {
      border-color: var(--color-accent);
      --tw-ring-color: var(--color-accent);
    }
  `;
  element.shadowRoot.append(style);
};
